<div class="local-activities__button-bar" *ngIf="tabType === 'activities'">
  <!-- <button mat-button class="local-activities__mat-btn-large" [class.local-activities__mat-btn-large--active]="selectedType === 'restaurant'"
          (click)="onClickActivityType('restaurant')">
    <mat-icon class="local-activities__icon" [svgIcon]="'activities:restaurant'"></mat-icon>
    Restaurants
  </button> -->
  <button mat-button class="local-activities__mat-btn-large" [class.local-activities__mat-btn-large--active]="selectedType === 'park'"
          (click)="onClickActivityType('park')">
    <mat-icon class="local-activities__icon" [svgIcon]="'activities:parks'"></mat-icon>
    Outdoor
  </button>
  <button mat-button class="local-activities__mat-btn-large" [class.local-activities__mat-btn-large--active]="selectedType === 'golf'"
          (click)="onClickActivityType('golf')">
    <mat-icon class="local-activities__icon" [svgIcon]="'activities:golf'"></mat-icon>
    Golf
  </button>
  <button mat-button class="local-activities__mat-btn-large" [class.local-activities__mat-btn-large--active]="selectedType === 'skiing'"
          (click)="onClickActivityType('skiing')">
    <mat-icon class="local-activities__icon" [svgIcon]="'activities:skiing'"></mat-icon>
    Skiing
  </button>
  <button mat-button class="local-activities__mat-btn-large" [class.local-activities__mat-btn-large--active]="selectedType === 'fishing'"
          (click)="onClickActivityType('fishing')">
    <mat-icon class="local-activities__icon" [svgIcon]="'activities:fishing'"></mat-icon>
    Sport Fishing
  </button>
  <button mat-button class="local-activities__mat-btn-large" [class.local-activities__mat-btn-large--active]="selectedType === 'amusement_park'"
          (click)="onClickActivityType('amusement_park')">
    <mat-icon class="local-activities__icon" [svgIcon]="'activities:amusement_park'"></mat-icon>
    Amusement Parks
  </button>
  <button mat-button class="local-activities__mat-btn-large" [class.local-activities__mat-btn-large--active]="selectedType === 'museum'"
          (click)="onClickActivityType('museum')">
    <mat-icon class="local-activities__icon" [svgIcon]="'activities:museums'"></mat-icon>
    Museums
  </button>
  <button mat-button class="local-activities__mat-btn-large" [class.local-activities__mat-btn-large--active]="selectedType === 'national-and-state-parks'"
          (click)="onClickActivityType('national-and-state-parks')">
    <mat-icon class="local-activities__fa-icon" fontSet="fa" fontIcon="fa-tree"></mat-icon>
    State and National Parks
  </button>
  <!-- <button mat-button class="local-activities__mat-btn-large" [class.local-activities__mat-btn-large--active]="selectedType === 'lodging'"
          (click)="onClickActivityType('lodging')">
    <mat-icon class="local-activities__fa-icon" fontSet="fa" fontIcon="fa-bed"></mat-icon>
    Lodging
  </button> -->
</div>
<div class="local-activities">
  <div class="local-activities__left-panel">
      <div #listEl class="local-activities__list">
        <app-state-view [promise]="activitiesPromise">
          <loading-state [template]="loading"></loading-state>
          <empty-state [template]="primaryPlaceholder"></empty-state>
          <error-state [template]="error"></error-state>
          <content-state>
            <ng-container *ngIf="activities && activities.length > 0; else primaryPlaceholder">
              <div #activityEl class="local-activities__activity" *ngFor="let activity of activities"
                   [class.local-activities__activity--active]="activity === selectedActivity"
                   (mouseover)="onActivityItemHover(activity, true)"
                   (mouseout)="onActivityItemHover(activity, false)">
                <div class="local-activities__activity-header">
                  <a *ngIf="activity.url; else activityHeader" [href]="activity.url"
                     class="local-activities__activity-link" target="_blank">
                    <ng-container [ngTemplateOutlet]="activityHeader"></ng-container>
                    <mat-icon class="local-activities__external-link" fontSet="fa" fontIcon="fa-external-link"></mat-icon>
                  </a>
                  <ng-template #activityHeader>
                    <h4 class="local-activities__header-text">{{ activity.name }}</h4>
                  </ng-template>
                  <div class="local-activities__rating">
                    <star-rating
                      [starType]="'svg'"
                      [rating]="activity.rating"
                      [step]="0.1"
                      [showHalfStars]="true"
                      [staticColor]='"ok"'
                      [size]='"medium"'
                      [readOnly]="true">
                    </star-rating>
                  </div>
                </div>
                <div class="local-activities__activity-body">
                  <div *ngIf="activity.vicinity" class="local-activities__field">
                    <mat-icon class="local-activities__field-icon">location_on</mat-icon>
                    <div class="local-activities__field-value">{{ activity.vicinity }}</div>
                  </div>
                  <div *ngIf="activity.formatted_phone_number" class="local-activities__field">
                    <mat-icon class="local-activities__field-icon">phone</mat-icon>
                    <div class="local-activities__field-value">{{ activity.formatted_phone_number | phone }}</div>
                  </div>
                </div>
              </div>
            </ng-container>
          </content-state>
        </app-state-view>
      </div>
    <div class="local-activities__bottom-bar">
      <img src="assets/images/powered_by_google_on_white.png" class="local_activities__google-img" alt="powered by Google">
      <div class="local-activities__bottom-bar-buttons">
        <button mat-button class="local-activities__mat-btn-small" [disabled]="!hasPrevPage" (click)="onClickPrevPage()">Previous</button>
        <button mat-button class="local-activities__mat-btn-small" [disabled]="!hasNextPage" (click)="onClickNextPage()">Next</button>
      </div>
    </div>
  </div>
  <agm-map class="local-activities__map" [latitude]="airport.location.lat" [longitude]="airport.location.lon"
           [zoomControl]="true" [disableDefaultUI]="true" [streetViewControl]="false" [mapDraggable]="true"
           [fitBounds]="true" [scrollwheel]="true" [mapTypeControl]="true">
    <agm-marker #airportMarker
                [latitude]="airport.location.lat" [longitude]="airport.location.lon"
                [iconUrl]="'assets/icons/airport.png'"
                [openInfoWindow]="false"
                [agmFitBounds]="true"
                (markerClick)="onAirportMarkerClick()"
                (mouseOver)="onAirportMarkerHover(true)"
                (mouseOut)="onAirportMarkerHover(false)">
      <agm-info-window #airportInfoWindow>
        <div class="agm-info-window-content">
          {{airport.faaId}}
        </div>
      </agm-info-window>
    </agm-marker>
    <agm-marker #activityMarker
                *ngFor="let activity of activities"
                [latitude]="activity.geometry.location.lat()"
                [longitude]="activity.geometry.location.lng()"
                [iconUrl]="getIconUrl(activity)"
                [openInfoWindow]="false"
                [agmFitBounds]="true"
                (mouseOver)="onActivityMarkerHover(activity, true)"
                (mouseOut)="onActivityMarkerHover(activity, false)">
                <!-- (markerClick)="onActivityMarkerClick(activity)" -->
      <agm-snazzy-info-window #activityInfoWindow
                              [maxWidth]="420"
                              [padding]="2"
                              [fontSize]="11"
                              [shadow]="false"
                              [pointer]="true"
                              [closeWhenOthersOpen]="true"
                              [closeOnMapClick]="true"
                              [showCloseButton]="false"
                              [isOpen]="selectedActivity === activity">
        <ng-template>
          <app-places-info-window [activity]="activity"></app-places-info-window>
        </ng-template>
      </agm-snazzy-info-window>
    </agm-marker>
  </agm-map>
</div>
<ng-template #primaryPlaceholder>
  <div class="local-activities__list--empty">
    <div class="local-activities__placeholder">
      <mat-icon class="local-activities__placeholder-icon">info</mat-icon>
      There are no activities of the selected type within 50 miles of this airport.
    </div>
  </div>
</ng-template>
<ng-template #loading>
  <div class="local-activities__list--empty">
      <mat-spinner [diameter]="16" class="local-activities__spinner"></mat-spinner>
  </div>
</ng-template>
<ng-template #error>
  <div class="local-activities__list--empty">
    <div class="local-activities__placeholder">
      <mat-icon class="local-activities__placeholder-icon">warning</mat-icon>
      An error occurred loading activities information for this airport.  Please try back later.
    </div>
  </div>
</ng-template>

